import { memo } from 'react'
import { useGameStore, type CryptoAsset } from '@/store/gameStore'
import { hapticSelection } from '@/telegram'
import { cn } from '@/lib/utils'

const CRYPTO_OPTIONS: CryptoAsset[] = ['BTC', 'ETH', 'SOL']

export const CryptoDaySelector = memo(function CryptoDaySelector() {
  const { currentCrypto, setCurrentCrypto } = useGameStore()

  return (
    <div className="flex shrink-0 gap-1 sm:gap-1.5">
      {CRYPTO_OPTIONS.map((c) => (
        <button
          key={c}
          onClick={() => {
            hapticSelection()
            setCurrentCrypto(c)
          }}
          className={cn(
            'rounded-lg px-2 py-1 text-xs font-semibold tracking-wide transition-all active:scale-95 sm:px-4 sm:py-1.5',
            currentCrypto === c
              ? 'bg-[#22c55e]/15 text-[#22c55e] ring-1 ring-[#22c55e]/40'
              : 'text-[#64748b] hover:text-[#94a3b8]'
          )}
        >
          {c}
        </button>
      ))}
    </div>
  )
})
